// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#country-phone-input-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-right: auto;
  width: 100%;
}
#country-phone-input-wrapper #phone-country-code {
  max-width: 50px;
  margin-bottom: 16px;
}
#country-phone-input-wrapper #phone-number {
  --padding-top: 4px !important;
  --padding-bottom: 4px !important;
  --padding-start: 8px !important;
  margin-bottom: 12px;
  background: #ffffff;
}

ion-input ion-img {
  width: 23px !important;
  height: 16.43px;
  margin-right: 16px;
}

.type-selected {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: 4px;
}
.type-selected.not-specified {
  background: var(--ion-color-contact-chart-not-specified);
}
.type-selected.prospect {
  background: var(--ion-color-contact-chart-prospect-color);
}
.type-selected.client {
  background: var(--ion-color-contact-chart-client-color);
}

.error-feedback-wrapper {
  min-height: 18px;
  margin-top: 16px;
}
.error-feedback-wrapper .error-feedback {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/contacts-core/lib/components/contact-form/contact-form.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;AACF;AACE;EACE,eAAA;EACA,mBAAA;AACJ;AACE;EACE,6BAAA;EACA,gCAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAIE;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AADJ;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAFF;AAIE;EACE,wDAAA;AAFJ;AAKE;EACE,yDAAA;AAHJ;AAME;EACE,uDAAA;AAJJ;;AAQA;EACE,gBAAA;EACA,gBAAA;AALF;AAME;EACE,kBAAA;AAJJ","sourcesContent":["#country-phone-input-wrapper {\n  display: flex;\n  justify-content: flex-start;\n  margin-right: auto;\n  width: 100%;\n\n  #phone-country-code {\n    max-width: 50px;\n    margin-bottom: 16px;\n  }\n  #phone-number {\n    --padding-top: 4px !important;\n    --padding-bottom: 4px !important;\n    --padding-start: 8px !important;\n    margin-bottom: 12px;\n    background: #ffffff;\n  }\n}\n\nion-input {\n  ion-img {\n    width: 23px !important;\n    height: 16.43px;\n    margin-right: 16px;\n  }\n}\n\n.type-selected {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-right: 10px;\n  margin-top: 4px;\n\n  &.not-specified {\n    background: var(--ion-color-contact-chart-not-specified);\n  }\n\n  &.prospect {\n    background: var(--ion-color-contact-chart-prospect-color);\n  }\n\n  &.client {\n    background: var(--ion-color-contact-chart-client-color);\n  }\n}\n\n.error-feedback-wrapper {\n  min-height: 18px;\n  margin-top: 16px;\n  .error-feedback {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
